import { resetUserSession } from './caching';

/* eslint-disable import/prefer-default-export */
export const handleError = (error) => {
  if (error.status === 401) {
    resetUserSession();
    // eslint-disable-next-line no-undef,no-restricted-globals
    window.location.href =
      // eslint-disable-next-line no-restricted-globals
      location.hostname.indexOf('baanx.co.uk') > 0 ? '/iframeV2/view/timeout' : '/timeout';
  }
};
